import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_OBJECT_PROPERTIES_BY_GROUP = registerQuery({
  fieldName: 'automation_propertiesByGroup',
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    return http.get(`properties/v4/groups/${objectTypeId}`, {
      query: {
        includeProperties: true,
        includeFieldLevelPermission: true
      }
    }).then(({
      results
    }) => results);
  }
});